<template>
    <section id="piplife" class="py-6 sm:py-[5%]">
        <div class="grid grid-cols-1 sm:grid-cols-2 items-center gap-6 sm:gap-4">
            <div class="sm:pr-8">
                <div class="right-point">
                    <img src="/images/pip-life.webp" alt="PIP Life" class="w-full h-full object-cover" />
                </div>
            </div>
            <div class="flex flex-col gap-4 max-w-md px-4 sm:px-0 sm:pr-6 mx-auto sm:mx-0">
                <h2>Life at PIP Global Safety</h2>
                <p>Joining our company is an exhilerating opportunity that promises growth, innovation, and a vibrant
                    work environment. We foster a culture that values creativity, collaboration, and continuous
                    learning, empowering our employees to unleash their full potential.</p>
                <p>As a part of our team, you'll be at the forefront of groundbreaking projects, working alongside
                    talented individuals who are passionate about making a difference.</p>
                <pip-button to="/careers" variant="primary" pill class="w-fit mt-4">Join Us</pip-button>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: 'PIPLife'
}
</script>
<style lang="scss" scoped>
.right-point {
    clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
}

.sm\:py-\[5\%\] {
    @media (min-width: 640px) {
        padding-top: 3%;
        padding-bottom: 3%;
    }
}
</style>